<template>
    <div>
	      <transition name="fadeInUp">
            <div class="form" ref="selecrHot"  v-show="isRoomShow">
                <div class="form-box">
                    <div>
                        <label class="between">成人</label>
                        <select v-model="AdultCountVal">
                            <option value="1">1成人</option>
                            <option value="2">2成人</option>
                            <option value="3">3成人</option>
                            <option value="4">4成人</option>
                       <!--      <option value="5">5成人</option>
                            <option value="6">6成人</option>
                            <option value="7">7成人</option>
                            <option value="8">8成人</option> -->
                        </select>
                        <span>18岁以上</span>
                    </div>
                    <div>
                        <label class="between">儿童</label>
                        <select v-model="ChildrenCountVal" >
                            <option value="0">0儿童</option>
                            <option value="1">1儿童</option>
                            <option value="2">2儿童</option>
                        </select>
                        <span>0-17岁</span>
                    </div>
                </div>
                <div class="age" v-if="ChildrenCountVal>0">
                    <p>儿童年龄({{date|dateToYMD}}当天)</p>
                    <select v-model="ChildrenAgesVal[0]" v-if="ChildrenCountVal>=1">
                        <option value="0"><1岁</option>
                        <option value="1">1岁</option>
                        <option value="2">2岁</option>
                        <option value="3">3岁</option>
                        <option value="4">4岁</option>
                        <option value="5">5岁</option>
                        <option value="6">6岁</option>
                        <option value="7">7岁</option>
                        <option value="8">8岁</option>
                        <option value="9">9岁</option>
                        <option value="10">10岁</option>
                        <option value="11">11岁</option>
                        <option value="12">12岁</option>
                        <option value="13">13岁</option>
                        <option value="14">14岁</option>
                        <option value="15">15岁</option>
                        <option value="16">16岁</option>
                        <option value="17">17岁</option>
                    </select>
                    <select v-model="ChildrenAgesVal[1]" v-if="ChildrenCountVal==2">
                        <option value="0"><1岁</option>
                        <option value="1">1岁</option>
                        <option value="2">2岁</option>
                        <option value="3">3岁</option>
                        <option value="4">4岁</option>
                        <option value="5">5岁</option>
                        <option value="6">6岁</option>
                        <option value="7">7岁</option>
                        <option value="8">8岁</option>
                        <option value="9">9岁</option>
                        <option value="10">10岁</option>
                        <option value="11">11岁</option>
                        <option value="12">12岁</option>
                        <option value="13">13岁</option>
                        <option value="14">14岁</option>
                        <option value="15">15岁</option>
                        <option value="16">16岁</option>
                        <option value="17">17岁</option>
                    </select>
                </div>
                <div class="btn">
                    <div class="determine" @click="select">确定</div>
                    <div class="cancel" @click="cancel">取消</div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
    export default {
        name: "selecthotelPeople",
        props:{
            isRoomShow:{
                type:Boolean,
                default:false,
            },

            AdultCount:{
                type:Number,
                default:2,
            },
            ChildrenCount:{
                type:Number,
                default:1,
            },
            ChildrenAges:{
                type:Array,
                default: () => {
                  return []
                }
            },
        },
        data() {
            return {
              AdultCountVal:2,
              ChildrenCountVal:'0',
              ChildrenAgesVal:[],
              date:this.getDate(0),
            }
        },

        watch:{
          ChildrenCountVal(val){
            if(val ==0){
              this.ChildrenAgesVal = [];
            }else if(val == 1){
              if(!this.ChildrenAgesVal[0]){
                this.ChildrenAgesVal[0] = 5
              }
              this.ChildrenAgesVal.splice(1,1)
            }else{
              if(!this.ChildrenAgesVal[0]){
                this.ChildrenAgesVal[0] = 5
              }
              if(!this.ChildrenAgesVal[1]){
                this.ChildrenAgesVal[1] = 5
              }
            }
          }
        },
        mounted() {
            this.AdultCountVal=this.AdultCount;
            this.ChildrenCountVal=this.ChildrenCount;
            this.ChildrenAgesVal=this.ChildrenAges;
        },
        methods: {
          cancel(){
            this.$emit('select','close');
          },
          select(){
            this.$emit('select',this.AdultCountVal,this.ChildrenCountVal,this.ChildrenAgesVal);
          },
 
        }
    }
</script>

<style scoped>
.form {
    width: 235px;
    position: absolute;
    top: 50px;
    left: 0;
    border: 1px solid #e6e6e6;
    background: #FFF;
    z-index: 2;
    padding: 10px;
  }
.form .age{
  padding-bottom: 0;
}
.age p{
  font-size: 13px;
}
  .btn{
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/common/cmpnt/searchBox/room.vue